import {getBontu} from "./requests";

const requestPath = "/request/generic/";

export function getRquestData(id){    
	return getBontu(requestPath+id, {}, {});
}
